import ChallengeCurationForm from './ChallengeCurationForm';

export default ChallengeCurationForm;
